//context
import { AuthProvider } from "./context/AuthContext";
import { RoadwaysBannerProvider } from "./context/RoadwaysBannerContext";

//components
import BasicLayout from "./components/Layout/BasicLayout";

export default function App() {
  return (
    <AuthProvider>
      <RoadwaysBannerProvider>
        <BasicLayout />
      </RoadwaysBannerProvider>
    </AuthProvider>
  );
}